import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {
    NaturalLanguageQueryRequest,
    NaturalLanguageQueryResponse
} from "../../model/dto/api/ai-segment-suggestion.interface";
import {AiNaturalLanguageQueryDto} from "../../model/dto/entity/ai-natural-language-query.dto";

/**
 * Service for natural language query processing.
 * F-024: AI-Powered Segment Suggestions - Acceptance Criteria: Given natural language input,
 * when processed, then corresponding filter criteria are generated.
 */
@Injectable({
    providedIn: 'root'
})
export class AiNaturalLanguageQueryService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/aiNaturalLanguageQueries')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-comment-dots';
    }

    /**
     * Processes a natural language query.
     * F-024: Acceptance Criteria - "Given natural language input, when processed,
     * then corresponding filter criteria are generated"
     */
    processQuery(request: NaturalLanguageQueryRequest): Observable<NaturalLanguageQueryResponse> {
        return this.postGeneric<NaturalLanguageQueryResponse>(request, '/process');
    }

    /**
     * Provides clarification for an ambiguous query.
     */
    provideClarification(queryId: number, clarifications: { [key: string]: string }): Observable<NaturalLanguageQueryResponse> {
        return this.postGeneric<NaturalLanguageQueryResponse>(clarifications, `/${queryId}/clarify`);
    }

    /**
     * Accepts a query result.
     */
    acceptQuery(queryId: number, wasModified: boolean = false): Observable<void> {
        return this.postGeneric<void>({}, `/${queryId}/accept?wasModified=${wasModified}`);
    }

    /**
     * Gets recent queries for a user.
     */
    getRecentQueries(userId: number): Observable<AiNaturalLanguageQueryDto[]> {
        return this.getGeneric<AiNaturalLanguageQueryDto[]>(`/recent/${userId}`);
    }

    /**
     * Gets queries needing clarification for a user.
     */
    getQueriesNeedingClarification(userId: number): Observable<AiNaturalLanguageQueryDto[]> {
        return this.getGeneric<AiNaturalLanguageQueryDto[]>(`/needsClarification/${userId}`);
    }
}
